export const Actions = Object.freeze({
  ADD_AUDIO_ADS_TO_QUEUE: 'ADD_AUDIO_ADS_TO_QUEUE',
  REMOVE_AUDIO_AD_FROM_QUEUE: 'REMOVE_AUDIO_AD_FROM_QUEUE',
  CLEAR_AUDIO_AD_QUEUE: 'CLEAR_AUDIO_AD_QUEUE',
  INCREMENT_AUDIO_AD_INDEX: 'INCREMENT_AUDIO_AD_INDEX',
  SET_AUDIO_ANALYTICS_CONTEXT: 'SET_AUDIO_ANALYTICS_CONTEXT',
  AUDIO_AD_START: 'AUDIO_AD_START',
  AUDIO_AD_END: 'AUDIO_AD_END',
  AUDIO_AD_FIRST_QUARTILE: 'AUDIO_AD_FIRST_QUARTILE',
  AUDIO_AD_MIDPOINT: 'AUDIO_AD_MIDPOINT',
  AUDIO_AD_THIRD_QUARTILE: 'AUDIO_AD_THIRD_QUARTILE',
  AUDIO_AD_SKIPPED: 'AUDIO_AD_SKIPPED',
  SET_ADSWIZZ_AD_ID: 'SET_ADSWIZZ_AD_ID',
  ADSWIZZ_API_FAIL: 'ADSWIZZ_API_FAIL',
  REGISTER_AUDIO_AD_TILE_IMPRESSION: 'REGISTER_AUDIO_AD_TILE_IMPRESSION',
  CLICKED_ADSWIZZ_AUDIO_AD_TILE: 'CLICKED_ADSWIZZ_AUDIO_AD_TILE',
  REGISTER_IMPRESSION_SUCCESS: 'REGISTER_IMPRESSION_SUCCESS',
  LOG_SKIPPABILITY_EXPOSURE_EVENT: 'LOG_SKIPPABILITY_EXPOSURE_EVENT',
  LOG_OM_SDK_EXPOSURE_EVENT: 'LOG_OM_SDK_EXPOSURE_EVENT',
});

export const Constants = Object.freeze({
  PRELOAD_TIME_SEC: 10,
  AUDIO_AD_TRACK_TYPE: 'AUDIO_AD',
});

// We need to maintain order of URLs otherwise we may not get Adswizz ID. So assigning to array
export const AdsWizzApiEndpoints = Object.freeze([
  'https://synchrobox.adswizz.com/register2.php',
  'https://cdn.adswizz.com/adswizz/js/SynchroClient2.js',
]);

export const ContentTypes = Object.freeze({
  DEVICE_AD: 'DEVICE_AD',
  EMPTY_AD: 'EMPTY_AD',
  PLAYLIST_AD: 'PLAYLIST',
  // adswizz
  VAST_AD: 'VAST_AD',
});

export const AdSources = Object.freeze({
  DFP: 'DFP',
});

export const VastTrackingEvents = Object.freeze({
  IMPRESSION: 'IMPRESSION',
  PAUSE: 'PAUSE',
  RESUME: 'RESUME',
  AUDIO_START: 'AUDIO_START',
  AUDIO_FIRST_QUARTILE: 'AUDIO_FIRST_QUARTILE',
  AUDIO_MIDPOINT: 'AUDIO_MIDPOINT',
  AUDIO_THIRD_QUARTILE: 'AUDIO_THIRD_QUARTILE',
  AUDIO_COMPLETE: 'AUDIO_COMPLETE',
  CLOSE: 'CLOSE',
  ERROR: 'ERROR',
  MUTE: 'MUTE',
  UNMUTE: 'UNMUTE',
  SKIP: 'SKIP',
});

export const EncodingTypes = Object.freeze({
  MP3: 'mp3',
  AAC: 'aac',
  M4A: 'm4a',
});

export const TrackerUrlTypes = Object.freeze({
  IMPRESSION: 'impression',
  TRACKER: 'tracking',
  TILE_TRACKER: 'tile_tracker',
});

export const TileTrackingEvents = Object.freeze({
  CLICK: 'CLICK',
  IMPRESSION: 'IMPRESSION',
});

export const AudioLifecycleActions = Object.freeze({
  AAD_LIFECYCLE_SET_ADSWIZZ_ID: 'aad_lifecycle_set_adswizz_id',
  AAD_LIFECYCLE_GET_AD_LIST: 'aad_lifecycle_get_ad_list',
  AAD_LIFECYCLE_PARSE_XML: 'aad_lifecycle_parse_xml',
  AAD_LIFECYCLE_ERROR: 'aad_lifecycle_error',
  AAD_LIFECYCLE_END: 'aad_lifecycle_end',
  AAD_LIFECYCLE_TRACKING_EVENT: 'aad_lifecycle_tracking_event',
  AAD_LIFECYCLE_REGISTER_IMPRESSION: 'aad_lifecycle_register_impression',
  AAD_LIFECYCLE_THROW_AUDIO_ADS: 'aad_lifecycle_throw_audio_ads',
  AAD_LIFECYCLE_PAUSE: 'AAD_LIFECYCLE_PAUSE',
  AAD_LIFECYCLE_RESUME: 'AAD_LIFECYCLE_RESUME',
  AAD_LIFECYCLE_MUTE: 'AAD_LIFECYCLE_MUTE',
  AAD_LIFECYCLE_UNMUTE: 'AAD_LIFECYCLE_UNMUTE',
});

export const AudioAnalyticsKeys = Object.freeze([
  'action',
  'ad_type',
  'correlation_id',
  'client_correlation_id',
  'creative_id',
  'duration',
  'line_id',
  'name',
  'reason',
  'station_id',
  'status',
  'tracking_event_type',
  'trigger_action',
  'url',
  'num_ads',
  'life_cycle_type',
  'adswizz_ad_id',
  'ad_blocker_enabled',
  'skip_offset',
  'playback_pos',
  'secondary_info',
]);

export const AudioPlaybackValues = Object.freeze({
  SUCCESS: 'success',
  FAILURE: 'failure',
  TRACKER: 'tracker',
});
